import React from 'react';
import PropTypes from 'prop-types';
import FilterListIcon from '@mui/icons-material/FilterList';
import { IconButton, Tooltip } from '@mui/material';
import Container from './styles/Container';

function Toolbar({ toogleFilters }) {
  return (
    <Container>
      <Tooltip title="Фильтры">
        <IconButton onClick={toogleFilters}>
          <FilterListIcon />
        </IconButton>
      </Tooltip>
    </Container>
  );
}

Toolbar.propTypes = {
  toogleFilters: PropTypes.func.isRequired,
};

export default Toolbar;
